export default "__VITE_ASSET__lmk1576l__"